import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  ButtonGroup,
  CustomInput,
} from "reactstrap";
import { injectIntl } from "react-intl";

import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import ThumbListIcon from "../../../components/ThumbListIcon";
import DataListIcon from "../../../components/DataListIcon";

const formatDatasExport = (data) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      Stt: i + 1,
      "Tên nhà cung cấp": data[i].name,
      "Số điện thoại": data[i].phone,
      Email: data[i].email,
      "Địa chỉ": data[i].address,
      "Mặt hàng cung cấp": data[i].company_provider_item.map(
        (item) => item.name,
      ),
      "Tổng tiền nhập": data[i].total_price_income,
      "Tổng đã trả": data[i].total_price_outcome,
      "Còn lại": data[i].total_price_pending,
      "Thời gian bắt đầu nhập": data[i].createdAt,
      "Thời gian nhập gần nhất": data[i].updatedAt,
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownSplitOpen: false,
    };
  }

  handleDownloadData = () => {
    const fileName = "Danh sách Nhà cung cấp";

    exportToCSV({
      csvData: formatDatasExport(this.props.data),
      fileName,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const {
      data,
      heading,
      setting,
      match,
      totalItem,
      toggleFunc,
      isDisabledAdd,
      changePageSizeFunc,
      onSearchKeyFunc,
      displayMode,
      changeDisplayMode,
    } = this.props;

    // console.log('render PageHeadingComponent');
    // console.log('data: ', data);

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    const { displayOptionsIsOpen } = this.state;
    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <h1 className="mb-0 mr-2">
                <IntlMessages id={heading} />
              </h1>
              <Breadcrumb match={match} />
            </div>
            <div className="text-zero top-right-button-container d-flex align-items-center">
              {/* Excel Download Button - Outside Dropdown */}
              <Button
                color="outline-primary"
                className="mr-2 excel-export-pages top-right-button"
                onClick={this.handleDownloadData}
                title="Tải dữ liệu về file Excel"
              >
                <i className="simple-icon-cloud-download mr-1" />
                Excel
              </Button>

              <ButtonGroup>
                <Button
                  color="primary"
                  className={classnames("top-right-button", {
                    disable: isDisabledAdd,
                  })}
                  onClick={() => toggleFunc()}
                >
                  <IntlMessages id="pages.add-new" />
                </Button>

                {/* <div className="btn btn-primary btn-lg pl-4 pr-0 check-button check-all">
                  <CustomInput
                    className="custom-checkbox mb-0 d-inline-block"
                    type="checkbox"
                    id="checkAll"
                    checked={
                      this.props.selectedItemsLength >=
                        this.props.itemsLength && this.props.itemsLength > 0
                    }
                    onChange={() => this.props.handleChangeSelectAll(true)}
                    label={
                      <span
                        className={`custom-control-label ${
                          this.props.selectedItemsLength > 0 &&
                          this.props.selectedItemsLength <
                            this.props.itemsLength
                            ? "indeterminate"
                            : ""
                        }`}
                      />
                    }
                  />
                </div> */}

                {this.props.selectedItemsLength > 0 &&
                  !this.props.isDisabledDelete && (
                    <Button
                      color="danger"
                      className="top-right-button"
                      onClick={this.props.onHandlerDelete}
                    >
                      <i className="simple-icon-trash mr-1" />
                      <IntlMessages id="pages.delete" /> (
                      {this.props.selectedItemsLength})
                    </Button>
                  )}
              </ButtonGroup>
            </div>
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <span className=" d-none d-md-flex mr-3 d-inline-block float-md-left ">
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "list" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("list");
                  }}
                >
                  <DataListIcon />
                </a>
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "thumblist" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("thumblist");
                  }}
                >
                  <ThumbListIcon />
                </a>
              </span>
              {/* Ẩn search input nếu sử dụng Navbar search (hideSearch=true) */}
              {!this.props.hideSearch && (
                <div className="d-block d-md-inline-block">
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder={messages["company-provider.search"]}
                      onKeyPress={(e) => onSearchKeyFunc(e)}
                      onChange={(e) => onSearchKeyFunc(e)}
                    />
                  </div>
                </div>
              )}
              {displayMode === "list" ? null : (
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {setting.selectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {setting.pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSizeFunc(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
